// Reactstrap wrapper components with default transition settings for React 18 compatibility
import React from 'react'
import {
  Alert as ReactstrapAlert,
  Fade,
  Tooltip as ReactstrapTooltip,
  UncontrolledTooltip as ReactstrapUncontrolledTooltip
} from 'reactstrap'

// Re-export everything from reactstrap first, then override specific components below
export * from 'reactstrap'

// Use Fade.defaultProps to ensure all required transition props are present
const DEFAULT_TRANSITION = {
  ...Fade.defaultProps,
  timeout: 150
}

// Alert with default transition (overrides reactstrap export)
export const Alert = (props) => (
  <ReactstrapAlert {...props} transition={DEFAULT_TRANSITION} />
)

// Tooltip with transition timeout to fix reactstrap 9.x bug
// Note: transition prop is not forwarded by TooltipPopoverWrapper, so warning persists
// See: https://github.com/reactstrap/reactstrap/issues/2819
export const Tooltip = (props) => (
  <ReactstrapTooltip {...props} />
)

export const UncontrolledTooltip = (props) => (
  <ReactstrapUncontrolledTooltip {...props} />
)
